// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { magnifyingGlass16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-magnifying-glass': IconMagnifyingGlass;
    }
}

/**
 * The icon component for the 'magnifyingGlass' icon
 */
export class IconMagnifyingGlass extends IconSvg {
    public constructor() {
        super(magnifyingGlass16X16);
    }
}

registerIconSvg('icon-magnifying-glass', IconMagnifyingGlass);
export const iconMagnifyingGlassTag = 'nimble-icon-magnifying-glass';
